import { ColorOptions } from '@jfs/ui-new'
import { Dimensions } from 'react-native'
import { BoxProps } from '../BoxNew'
import { IconProps } from '../IconNew'
import { TextProps } from '../TextNew/index'

const { width }: any = Dimensions.get('window')
const isMobile = width <= 550

const innerContainer = {
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  paddingHorizontal: 6,
  paddingVertical: 3,
  backgroundColor: 'BRAND_PRIMARY_WHITE',
} as BoxProps

const iconStyle = {
  color: 'BLACK',
  size: 14,
} as IconProps

const textStyle = {
  color: 'BLACK',
  fontSize: 14,
  fontWeight: 'FONT_WEIGHT_LIGHT',
} as TextProps

export const defaultStyle = {
  underlayColor: 'WHITE_DIM',
  container: {
    padding: 4,
    alignItems: 'center',
    justifyContent: 'center',
  } as BoxProps,
  state: {
    normal: {
      innerContainer: { ...innerContainer } as BoxProps,
      iconStyle: { ...iconStyle } as IconProps,
      textStyle: { ...textStyle } as TextProps,
    },
    selected: {
      innerContainer: {
        ...innerContainer,
        backgroundColor: 'BRAND_PRIMARY_WHITE_CLICKED',
        borderBottomWidth: 1,
        borderBottomColor: 'BRAND_PRIMARY_ACTION',
      } as BoxProps,
      iconStyle: { ...iconStyle, color: 'BRAND_PRIMARY_ACTION' } as IconProps,
      textStyle: { ...textStyle, color: 'BRAND_PRIMARY_ACTION' } as TextProps,
    },
  },
}

export const jpbStyle = {
  underlayColor: {
    underlayColor: 'WHITE_DIM',
    marginTop: 7,
  } as BoxProps,
  container: {
    padding: 8,
    alignItems: 'center',
    justifyContent: 'center',
  } as BoxProps,
  state: {
    normal: {
      innerContainer: {
        ...innerContainer,
        backgroundColor: '#F1F2F2' as ColorOptions,
        paddingHorizontal: 20,
        paddingVertical: 8,
        marginRight: isMobile ? 0 : 2,
      } as BoxProps,
      iconStyle: { ...iconStyle } as IconProps,
      textStyle: {
        ...textStyle,
        fontFamily: 'roboto-regular',
        color: '#00000080' as any,
        fontWeight: 'bold',
      } as TextProps,
    },
    selected: {
      innerContainer: {
        ...innerContainer,
        paddingHorizontal: 20,
        paddingVertical: 8,
        backgroundColor: '#DF9F39' as ColorOptions,
        borderBottomWidth: 0,
        marginRight: isMobile ? 0 : 2,
        borderBottomColor: 'BRAND_PRIMARY_ACTION',
      } as BoxProps,
      iconStyle: { ...iconStyle, color: 'BRAND_PRIMARY_ACTION' } as IconProps,
      textStyle: { ...textStyle, fontFamily: 'roboto-regular', color: 'WHITE', fontWeight: '600' } as TextProps,
    },
  },
}

export const tabTypes = {
  default: { ...defaultStyle },
  jpb: { ...jpbStyle },
}
